import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './CreditCards.css';

const CreditCards = ({ onClose }) => {
  const { authFetch, user } = useAuth();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    limite: '',
    dia_fechamento: 1,
    dia_vencimento: 10,
    cor: '#3b82f6',
    isBusiness: false,
  });

  const fetchCards = async () => {
    try {
      setLoading(true);
      const res = await authFetch('/api/cards');
      if (res.ok) {
        setCards(await res.json());
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, [authFetch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await authFetch('/api/cards', {
        method: 'POST',
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setShowForm(false);
        fetchCards();
        setFormData({ ...formData, nome: '', limite: '' });
      } else {
        alert('Erro ao criar cartão');
      }
    } catch (err) {
      alert('Falha na conexão.');
    }
  };

  const deleteCard = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este cartão? Histórico pode ser afetado.')) return;
    try {
      const res = await authFetch(`/api/cards/${id}`, { method: 'DELETE' });
      if (res.ok) fetchCards();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{maxWidth: '800px', width: '90%', maxHeight: '90vh', overflowY: 'auto', padding: '24px'}} onClick={e => e.stopPropagation()}>
        <div className="cards-header">
          <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
            <h2>💳 Meus Cartões de Crédito</h2>
            <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
              {showForm ? 'Cancelar' : '+ Novo Cartão'}
            </button>
          </div>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

      {showForm && (
        <form className="cards-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Cartão (Ex: Nubank, Itaú)</label>
            <input type="text" value={formData.nome} onChange={e=>setFormData({...formData, nome:e.target.value})} required />
          </div>
          <div className="form-group">
            <label>Limite Total (R$)</label>
            <input type="number" step="0.01" value={formData.limite} onChange={e=>setFormData({...formData, limite:e.target.value})} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Dia de Fechamento</label>
              <input type="number" min="1" max="31" value={formData.dia_fechamento} onChange={e=>setFormData({...formData, dia_fechamento:e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Dia de Vencimento</label>
              <input type="number" min="1" max="31" value={formData.dia_vencimento} onChange={e=>setFormData({...formData, dia_vencimento:e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Cor do Cartão</label>
              <input type="color" value={formData.cor} onChange={e=>setFormData({...formData, cor:e.target.value})} />
            </div>
          </div>
          {user?.business_id && (
            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" id="cc-business" checked={formData.isBusiness} onChange={e=>setFormData({...formData, isBusiness:e.target.checked})} />
              <label htmlFor="cc-business" style={{ margin: 0 }}>Compartilhar cartão com o Business: <strong>{user.nome_business}</strong></label>
            </div>
          )}
          <button type="submit" className="btn-primary">Salvar Cartão</button>
        </form>
      )}

      {loading ? <p>Carregando...</p> : (
        <div className="cards-grid">
          {cards.length === 0 ? (
            <div className="no-cards">Nenhum cartão cadastrado.</div>
          ) : (
            cards.map(c => (
              <div key={c.id} className="card-item" style={{ borderTop: `4px solid ${c.cor || '#3b82f6'}` }}>
                <div className="card-top">
                  <h3>{c.nome}</h3>
                  <button className="del-btn" onClick={() => deleteCard(c.id)}>🗑️</button>
                </div>
                <div className="card-info">
                  <p><span>Limite:</span> R$ {parseFloat(c.limite).toFixed(2).replace('.',',')}</p>
                  <p><span>Fechamento:</span> Dia {c.dia_fechamento}</p>
                  <p><span>Vencimento:</span> Dia {c.dia_vencimento}</p>
                  {c.business_id && <span className="group-badge">Cartão Compartilhado</span>}
                </div>
                {/* Aqui futuramente carregaremos faturas */}
                <button className="btn-secondary faturas-btn">Ver Faturas</button>
              </div>
            ))
          )}
        </div>
      )}
      </div>
    </div>
  );
};

export default CreditCards;
